import { LogOut } from "lucide-react";
import { useTranslation } from "react-i18next";
import { getImpersonatorId, getUser } from "@/src/auth/store/auth-selectors";
import { Button } from "@/src/common/components/ui";
import { buildMainAppUrl } from "@/src/common/lib/subdomain";
import { useAppSelector } from "@/src/common/redux/store";
import { toastService } from "@/src/common/services/toast.service";
import { STAFF_ROUTES } from "../constants/staff-routes";
import { useExitImpersonationMutation } from "../services/staff-http.service";

export function ImpersonationBanner() {
	const { t } = useTranslation("staff");
	const impersonatorId = useAppSelector(getImpersonatorId);
	const currentUser = useAppSelector(getUser);
	const [exitImpersonation, { isLoading: isExiting }] = useExitImpersonationMutation();

	if (!impersonatorId) return null;

	const displayName = currentUser ? [currentUser.first_name, currentUser.last_name].filter(Boolean).join(" ") : "";

	const handleExit = async () => {
		try {
			await exitImpersonation().unwrap();
			window.location.href = buildMainAppUrl(STAFF_ROUTES.COMMUNITIES);
		} catch {
			toastService.error(t("exit_impersonation_error"));
		}
	};

	return (
		<div className="sticky top-0 z-50 flex items-center justify-between gap-3 bg-warning px-4 py-2 text-warning-foreground">
			<span className="text-sm font-medium">{t("impersonation_banner", { name: displayName })}</span>
			<Button size="sm" variant="secondary" isPending={isExiting} onPress={handleExit}>
				<LogOut size={14} />
				{t("exit_impersonation")}
			</Button>
		</div>
	);
}
